import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { PresenceDataModeType, SnCamera } from '@lib/api/entities';
import { FsMapSwitchableDeviceDataServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapSwitchableDeviceDataFacadeService<
  TMap extends IFsMap,
  TMarker,
> extends FsMapSwitchableDeviceDataServiceProvider<TMap, TMarker> {
  constructor(private readonly provider: FsMapSwitchableDeviceDataServiceProvider<TMap, TMarker>) {
    super();
  }

  public get dock$(): Observable<TMarker> {
    return this.provider.dock$;
  }

  public get dockNearbyCameras$(): Observable<SnCamera> {
    return this.provider.dockNearbyCameras$;
  }

  public get hovered$(): Observable<TMarker> {
    return this.provider.hovered$;
  }

  public get mouseOut$(): Observable<void> {
    return this.provider.mouseOut$;
  }

  public get advancedMarkers(): TMarker[] {
    return this.provider.advancedMarkers;
  }
  public selectMarkerByDeviceId$(deviceId: string): Observable<TMarker> {
    return this.provider.selectMarkerByDeviceId$(deviceId);
  }

  public onMapLoaded(map: TMap): void {
    this.provider.onMapLoaded(map);
  }

  public setupListeners(): void {
    this.provider.setupListeners();
  }

  public viewOnMap(marker: TMarker): void {
    this.provider.viewOnMap(marker);
  }

  public findMarkerAndSelect(marker: TMarker): void {
    this.provider.findMarkerAndSelect(marker);
  }

  public dockStream(marker: TMarker): void {
    this.provider.dockStream(marker);
  }

  public addToMap(): void {
    this.provider.addToMap();
  }

  public removeFromMap(): void {
    this.provider.removeFromMap();
  }

  public getCurrentMode(): PresenceDataModeType {
    return this.provider.getCurrentMode();
  }

  public shouldUseShadowMode(): boolean {
    return this.provider.shouldUseShadowMode();
  }

  public shouldUseDSA(): boolean {
    return this.provider.shouldUseDSA();
  }

  public shouldUsePresenceApi(): boolean {
    return this.provider.shouldUsePresenceApi();
  }
}
